import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

const plugins = []

if (typeof window !== "undefined") {
  plugins.push(createPersistedState())
}

Vue.use(Vuex)

export function createStore() {
  return new Vuex.Store({
     plugins,
    state: {
      currentot: 1,
      betfaircom: 5,
      betdaqcom: 2,
      smarketcom: 2,          // fixed typo
      timediff: 0,
      tzdesc: '',
      authtype: '',
      email: '',
      username: '',
      signedin: false,
      country: '',
      sb: [],
      nameid: 0,
      sports: [],
      oats: [],
      selectedoat: 0,
      adbanners: [],
      filterbysport: [],
      countryname: '',
      ipaddress: '',
      regbody: [],
      popcomps: [],
      favourites: [],
      users: [],
      countryiso: 'EN',
      currency: '',
      isadmin: false,
      obfuscatedname: '',
      sitename: 'Oddsgalore',
      bespokebookies: false,
      sessiontime: '',
      showhints: false,
      advertsloaded: false,
      nopromo: -99,
      langtranslationfile: [],
      langfileloaded: false,
      leftside: false,
      rightside: false,
      eventparams: [],
      bid: 0,
      bettype: '',
      features: [], // json for features.vue
      competitionsforsportstable: [], // json for sports.vue
      wasSSR: false,
      ads: [],
      bookmakers: [],
      odds: []
    },
    mutations: {
      setCurrentot(state, val){ state.currentot = val },
      setBetfaircom(state, val){ state.betfaircom = val },
      setBetdaqcom(state, val){ state.betdaqcom = val },
      setSmarketcom(state, val){ state.smarketcom = val },
      setTimediff(state, val){ state.timediff = val },
      setTzdesc(state, val){ state.tzdesc = val },
      setAuthtype(state, val){ state.authtype = val },
      setEmail(state, val){ state.email = val },
      setName(state, val){ state.username = val },
      setSignedin(state, val){ state.signedin = val },
      setCountry(state, val){ state.country = val },
      setSelectedbookmakers(state,val){ state.sb = val },
      setNameID(state, val){ state.nameid = val },
      setSports(state, val){ state.sports = val },
      setOatTypes(state, val){ state.oats = val },
      setOat(state, val){ state.selectedoat = val },
      setAdbanners(state, val){ state.adbanners = val },
      setFilterbysport(state, val){ state.filterbysport = val },
      setCountryName(state, val){ state.countryname = val },
      setIPAddress(state,val){ state.ipaddress = val },
      setRegBody(state,val){ state.regbody = val },
      setPopComps(state,val){ state.popcomps = val },
      setFavourites(state,val){ state.favourites = val },
      setUsers(state,val){ state.users = val },
      setCountryISO(state,val){ state.countryiso = val },
      setCurrency(state,val){ state.currency = val },
      setisAdmin(state,val){ state.isadmin = val },
      setObfuscatedName(state,val){ state.obfuscatedname = val },
      setSiteName(state,val){ state.sitename = val },
      setBespokeBookies(state,val){ state.bespokebookies = val },
      setSessionTime(state,val){ state.sessiontime = val },
      setShowHints(state,val){ Vue.set(state,'showhints', val) },
      setAdvertsLoaded(state,val){ Vue.set(state,'advertsloaded', val) },
      setNoPromo(state,val){ Vue.set(state,'nopromo', val) },
      setLangTranslationFile(state,val){ Vue.set(state,'langtranslationfile', val) },
      setLangFileLoaded(state,val){ Vue.set(state,'langfileloaded', val) },
      setLeftSide(state,val){ Vue.set(state,'leftside', val) },
      setRightSide(state,val){ Vue.set(state,'rightside', val) },
      setEventParams(state,val){   if (Array.isArray(val)) {
    Vue.set(state, 'eventparams', val)
  } else {
    // ensure array exists
    if (!Array.isArray(state.eventparams)) {
      Vue.set(state, 'eventparams', [])
    }

    // set string as first element (reactive)
    state.eventparams.splice(0, 1, String(val))
  } },
      setBid(state,val){ Vue.set(state,'bid', val) },
      setBetType(state,val){ Vue.set(state,'bettype', val) },
      setFeatures(state,val){ Vue.set(state,'features', val) },
      setCompetitionsforSportsTable(state,val){Vue.set(state,'competitionsforsportstable', [...val]) },
      setAds(state,val){ Vue.set(state,'ads', val)  },
      setBookmakers(state,val){ Vue.set(state,'bookmakers', val)  },
      setOdds(state,val){ Vue.set(state,'odds', [...val])  },
      },
      

  })
}